import { mixed, object } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'

const characterLimit = 10_000

export const getValidationSchema = () => object({
  description: mixed()
    .test('description', '', (val, testContext) => {
      if (val.html?.length > characterLimit) {
        return testContext.createError({ message: I18n.t('errors.messages.too_long', { count: characterLimit }) })
      }
      return true
    })
})
